const translations = {
  'NAO_REALIZADO': 'Não realizado',
  'REALIZADO': 'Realizado',
  'EM_PROCESSAMENTO': 'Em processamento'
}

const colors = {
  'NAO_REALIZADO': 'danger',
  'REALIZADO': 'success',
  'EM_PROCESSAMENTO': 'warning'
}

export {translations, colors}
